import { fromJS } from 'immutable';
import * as actionTypes from './actionTypes';

const initialState = fromJS({
  accountData: {
    isLoading: true,
    data: {},
    error: ''
  },
  taxReceipts: {
    isLoading: true,
    data: [],
    error: ''
  },
  completedContributions: {
    isLoading: true,
    data: [],
    error: '',
    dataAvailableForNextRequest: true
  },
  pendingContributions: {
    isLoading: true,
    data: [],
    error: '',
    dataAvailableForNextRequest: true
  },
  isLazyLoading: false,
  initialPendingData: 10,
  initialCompletedData: 10,
  enableLazyLoading: true,
  contributionDashboard_data: {
    isLoadingBot: true,
    data: [],
    error: '',
    botStatusText: 'Searching for results in the data range',
    data_y3: false,
    data_y5: false
  },
  contributionDashboard_data_all: {
    isLoadingBot: true,
    data: [],
    error: '',
    botStatusText: 'Seaching for results in the data range',
    data_all_y3: false,
    data_all_y5: false
  },
  chartData: {
    isLoading: false,
    show: false,
    data: {},
    error: ''
  },
  value_your_contributions: {
    isLoading: false,
    data: null,
    error: ''
  },
  ytdData: {
    isLoading: false,
    data: null,
    error: ''
  },
  additionalAccountDetails: {
    establishedDate: 1408645800000
  }
});

const contributionsDashboard = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.resetDataType:
      return state
        .setIn(['chartData', 'isLoading'], false)
        .setIn(['chartData', 'show'], false)
        .setIn(['chartData', 'data'], null)
        .setIn(['chartData', 'error'], null)
        .setIn(['accountData', 'data'], {})
        .setIn(['accountData', 'isLoading'], true)
        .setIn(['taxReceipts', 'isLoading'], true)
        .setIn(['taxReceipts', 'data'], [])
        .setIn(['completedContributions', 'isLoading'], true)
        .setIn(['completedContributions', 'data'], [])
        .setIn(['completedContributions', 'dataAvailableForNextRequest'], true)
        .setIn(['pendingContributions', 'isLoading'], true)
        .setIn(['pendingContributions', 'data'], [])
        .setIn(['pendingContributions', 'dataAvailableForNextRequest'], true)
        .setIn(['isLazyLoading'], false)
        .setIn(['initialPendingData'], 10)
        .setIn(['initialCompletedData'], 10)
        .setIn(['enableLazyLoading'], true)
        .setIn(['contributionDashboard_data', 'isLoadingBot'], true)
        .setIn(['contributionDashboard_data', 'data'], [])
        .setIn(
          ['contributionDashboard_data', 'botStatusText'],
          'Searching for results in the data range'
        )
        .setIn(['contributionDashboard_data', 'data_y3'], false)
        .setIn(['contributionDashboard_data', 'data_y5'], false)
        .setIn(['contributionDashboard_data_all', 'isLoadingBot'], false)
        .setIn(['contributionDashboard_data_all', 'data'], [])
        .setIn(
          ['contributionDashboard_data_all', 'botStatusText'],
          'Searching for results in the data range'
        )
        .setIn(['contributionDashboard_data_all', 'data_all_y3'], false)
        .setIn(['contributionDashboard_data_all', 'data_all_y5'], false)
        .setIn(['ytdData', 'isLoading'], false)
        .setIn(['ytdData', 'data'], null);
    case actionTypes.ytdDataFetchSuccessType:
      return state
        .setIn(['ytdData', 'data'], action.payload)
        .setIn(['ytdData', 'isLoading'], false);
    case actionTypes.ytdDataFetchFailedType:
      return state
        .setIn(['ytdData', 'error'], action.payload)
        .setIn(['isLoading'], false);
    case actionTypes.ytdDataFetchLoadingType:
      return state.setIn(['ytdData', 'isLoading'], true);
    case actionTypes.accountDataFetchLoadingType:
      return state.setIn(['accountData', 'isLoading'], true);
    case actionTypes.accountDataSuccessType:
      return state
        .setIn(['accountData', 'data'], action.payload)
        .setIn(['accountData', 'isLoading'], false);
    case 'ACCOUNT_DATA_FAILED':
      return state
        .setIn(['accountData', 'error'], action.payload)
        .setIn(['accountData', 'isLoading'], false);
    case actionTypes.valueYourContributionsLoadingType:
      return state.setIn(['value_your_contributions', 'isLoading'], true);
    case actionTypes.valueYourContributionsSuccessType:
      return state
        .setIn(['value_your_contributions', 'isLoading'], false)
        .setIn(['value_your_contributions', 'data'], action.payload);
    case actionTypes.valueYourContributionsFailedType:
      return state
        .setIn(['value_your_contributions', 'error'], action.payload)
        .setIn(['value_your_contributions', 'isLoading'], false);
    case actionTypes.lazyLoadDataLoaderType:
      return state.setIn(['isLazyLoading'], true);
    case actionTypes.lazyLoadCompletedDataSuccessType:
      return state
        .setIn(['isLazyLoading'], false)
        .setIn(
          ['completedContributions', 'dataAvailableForNextRequest'],
          action.payload.dataAvailableForNextRequest
        )
        .setIn(
          ['completedContributions', 'data'],
          [...action.payload.contributions]
        )
        .setIn(
          ['initialCompletedData'],
          state.getIn(['initialCompletedData']) + 10
        );
    case actionTypes.lazyLoadPendingDataSuccessType:
      return state
        .setIn(['isLazyLoading'], false)
        .setIn(
          ['pendingContributions', 'data'],
          [...action.payload.contributions]
        )
        .setIn(
          ['pendingContributions', 'dataAvailableForNextRequest'],
          action.payload.dataAvailableForNextRequest
        )
        .setIn(
          ['initialPendingData'],
          state.getIn(['initialPendingData']) + 10
        );
    case actionTypes.completedContributionsLoaderType:
      return state.setIn(['completedContributions', 'isLoading'], true);

    case actionTypes.completedContributionsSuccessType:
      return state
        .setIn(['completedContributions', 'data'], action.payload.contributions)
        .setIn(
          ['initialCompletedData'],
          state.getIn(['initialCompletedData']) + 10
        )
        .setIn(
          ['completedContributions', 'dataAvailableForNextRequest'],
          action.payload.dataAvailableForNextRequest
        )
        .setIn(
          ['completedContributions', 'isLoading'],
          !state.getIn(['completedContributions', 'isLoading'])
        );

    case actionTypes.pendingContributionLoaderType:
      return state.setIn(['pendingContributions', 'isLoading'], true);

    case actionTypes.pendingContributionSuccessType:
      return state
        .setIn(['pendingContributions', 'data'], action.payload.contributions)
        .setIn(['initialPendingData'], state.getIn(['initialPendingData']) + 10)
        .setIn(
          ['pendingContributions', 'dataAvailableForNextRequest'],
          action.payload.dataAvailableForNextRequest
        )
        .setIn(
          ['pendingContributions', 'isLoading'],
          !state.getIn(['pendingContributions', 'isLoading'])
        );

    case actionTypes.taxReciptsLoaderType:
      return state.setIn(['taxReceipts', 'isLoading'], true);

    case actionTypes.taxDataSuccessType:
      return state
        .setIn(
          ['taxReceipts', 'data'],
          action.payload['Contribution confirmations & tax records']
        )
        .setIn(['taxReceipts', 'isLoading'], false);

    case actionTypes.contributionsDashboardDataLoadingType:
      return state
        .setIn(['contributionDashboard_data', 'isLoadingBot'], true)
        .setIn(
          ['contributionDashboard_data', 'botStatusText'],
          'Searching for results in this date range'
        );

    case actionTypes.contributionsDashboardDataSuccessType:
      var text = 'No data available for this date range';
      if (action.payload.length && action.payload[0].y3) {
        text = 'Searching for results in the data range';
      } else {
        text = 'No data available for this date range';
      }
      return state
        .setIn(['contributionDashboard_data', 'data'], action.payload)
        .setIn(['contributionDashboard_data', 'isLoadingBot'], false)
        .setIn(['contributionDashboard_data', 'botStatusText'], text)
        .setIn(
          ['contributionDashboard_data', 'data_y3'],
          action.payload.length ? action.payload[0].y3 : false
        )
        .setIn(
          ['contributionDashboard_data', 'data_y5'],
          action.payload.length
            ? action.payload.length && action.payload[0].y5
            : false
        );

    case actionTypes.allContributionsDashboardDataLoadingType:
      return state.setIn(
        ['contributionDashboard_data_all', 'isLoadingBot'],
        true
      );

    case actionTypes.allContributionsDashboardDataSuccessType:
      return state
        .setIn(['contributionDashboard_data_all', 'data'], action.payload)
        .setIn(['contributionDashboard_data_all', 'isLoadingBot'], false)
        .setIn(
          ['contributionDashboard_data', 'botStatusText'],
          'No data available for this date range'
        )
        .setIn(
          ['contributionDashboard_data_all', 'data_all_y3'],
          action.payload.length ? action.payload[0].y3 : false
        )
        .setIn(
          ['contributionDashboard_data_all', 'data_all_y5'],
          action.payload.length ? action.payload[0].y5 : false
        );
    case actionTypes.storeChartDataLoadingType:
      return state
        .setIn(['chartData', 'isLoading'], true)
        .setIn(['chartData', 'show'], true)
        .setIn(['chartData', 'data'], null);
    case actionTypes.storeChartDataSuccessType:
      let zArray = action.payload.z;
      return state
        .setIn(['chartData', 'data'], zArray)
        .setIn(['chartData', 'isLoading'], false);
    case actionTypes.storeChartDataFailedType:
      return state
        .setIn(['chartData', 'isLoading'], false)
        .setIn(['chartData', 'error'], action.payload);
    case actionTypes.disableShowType:
      return state
        .setIn(['chartData', 'show'], false)
        .setIn(['chartData', 'isLoading'], false)
        .setIn(['chartData', 'data'], null)
        .setIn(['chartData', 'error'], null);
    case actionTypes.establishedDataSuccessType:
      return state.setIn(['additionalAccountDetails', 'data'], action.payload);
    default:
      return state;
  }
};

export default contributionsDashboard;
